import React from 'react';

import styles from './FixedFooter.module.scss';

import chevronRightWhite from '../../../public/images/chevron-right-white.svg';
import chevronLeftGrey from '../../../public/images/chevron-left-grey.svg';

const {
  'fixed-footer': fixedFooterClass,
  'main-content': mainFooterContentClass,
  'back-copy': backCopyClass,
  'mobile-only-copy': mobileCopyClass,
  back: backBtnClass,
  next: nextBtnClass
} = styles;

const FixedFooter = ({
  customClass,
  mainContentCustomClass,
  backCopy,
  nextCopy,
  nextButtonType = 'submit',
  isValid = false,
  renderAdditionalContent = null,
  renderAdditionalMobileContent = null,
  backAction = () => {},
  nextAction = () => {}
}) => {
  return (
    <div className={`${fixedFooterClass} ${customClass}`}>
      {renderAdditionalMobileContent && renderAdditionalMobileContent()}
      <div className={`${mainFooterContentClass} ${mainContentCustomClass}`}>
        {backCopy && (
          <button className={backBtnClass} onClick={backAction}>
            <img src={chevronLeftGrey} alt="left-chev" />
            <p className={backCopyClass}>{backCopy}</p>
            <p className={mobileCopyClass}>Back</p>
          </button>
        )}
        {renderAdditionalContent && renderAdditionalContent()}
        {nextCopy && (
          <button
            type={nextButtonType}
            className={nextBtnClass}
            onClick={nextAction}
            disabled={!isValid}
          >
            {nextCopy}
            <img src={chevronRightWhite} alt="right-chev" />
          </button>
        )}
      </div>
    </div>
  );
};

export default FixedFooter;
